package br.com.htms.inspeccaocampo.ui

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp

/** Asset logo_htms_header.png = 339×128. */
internal const val HTMS_LOGO_ASPECT = 339f / 128f
internal val HtmsLogoMaxHeight = 44.dp
internal val HtmsLogoMaxWidth = 117.dp

@Composable
expect fun HtmsHeaderLogo(modifier: Modifier = Modifier)

@Composable
fun HtmsHeaderTitle(
    subtitle: String,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier.padding(end = 4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        HtmsHeaderLogo()
        Spacer(Modifier.width(10.dp))
        Column {
            Text(
                text = subtitle,
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = FontWeight.SemiBold,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}
